import {
  initialState,
  Actions,
  State,
  NEW_INVITATION,
  NEW_INVITATION_SUCCESS,
  NEW_INVITATION_ERROR,
  RESET_NEW_INVITATION,
} from '../../types/invitation/new'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_INVITATION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case NEW_INVITATION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case NEW_INVITATION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_NEW_INVITATION:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
